<chart style="height: 1800px;"
       [type]="chartData.type"
       [datasets]="chartData.data.datasets"
       [labels]="chartData.data.labels"
       [options]="chartData.options">
</chart>
